<template>
  <div class="physio">
    <el-button icon="el-icon-refresh" @click="$refresh(getPhysiosList)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="货号">
            <el-input v-model.trim="searchForm.artNo" clearable placeholder="请输入货号" />
          </el-form-item>
          <el-form-item label="名称">
            <el-input v-model.trim="searchForm.searchValue" clearable placeholder="请输入名称/通用名称" />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.enableStatus" clearable placeholder="请选择状态">
              <el-option value="1" label="启用"></el-option>
              <el-option value="2" label="禁用"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="医保编码">
            <el-select v-model="searchForm.ybCode" clearable placeholder="请选择状态">
              <el-option value="" label="全部"></el-option>
              <el-option value="1" label="有"></el-option>
              <el-option value="2" label="无"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getPhysiosList, true)">查询</el-button>
            <el-button icon="el-icon-refresh"
              @click="$reset(getPhysiosList, { artNo: null, searchValue: null, enableStatus: '', ybCode:'' })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 理疗列表 -->
      <CustomTable v-loading="loading" :column="listTable" :tableData="physioList" :max-height="tableHeight">
        <template slot="firstCategory" slot-scope="{row}">
          {{ computedLevel(row.firstCategory) }}
        </template>
        <template slot="secondCategory" slot-scope="{row}">
          {{ computedLevel(row.secondCategory) }}
        </template>
        <template slot="unit" slot-scope="{row}">
          {{ row.unit || '-' }}
        </template>
        <template slot="enableStatus" slot-scope="{row}">
          <el-switch v-model="row.checked" @change="changeEnableStatusHandle($event, row)"></el-switch>
        </template>
        <template slot="handle" slot-scope="{row}">
          <el-button type="text" @click="handleEdit(row)" v-if="deptId == '0' || deptId == '-1'">查看</el-button>
        </template>
      </CustomTable>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getPhysiosList)" :total="total"
        :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
    </div>
    <!-- 弹框 -->
    <customDialog title="查看 请在理疗商品管理模块编辑" width="750px" v-if="dialogShow" :visible.sync="dialogShow" @close="closeDialog"
      @save="closeDialog">
      <el-descriptions slot="content" column="1">
        <el-descriptions-item label="货号">{{editForm.id}}</el-descriptions-item>
        <el-descriptions-item label="商品通用名称">{{ editForm.physioCommonName }}</el-descriptions-item>
        <el-descriptions-item label="单位">{{ editForm.unit }}</el-descriptions-item>
        <el-descriptions-item label="药品编码">{{ editForm.dictPhysioCode }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{ editForm.physioName }}</el-descriptions-item>
        <el-descriptions-item label="执行模式">
          <el-radio-group v-model="editForm.executionMode" disabled>
            <el-radio :label="10">按次执行</el-radio>
            <el-radio :label="20">按组执行</el-radio>
          </el-radio-group>
        </el-descriptions-item>
        <el-descriptions-item label="执行单位">
           <el-radio-group v-model="editForm.perUnit" disabled>
            <el-radio :label="10">穴位</el-radio>
            <el-radio :label="20">部位</el-radio>
            <el-radio :label="30">不限制</el-radio>
          </el-radio-group>
        </el-descriptions-item>
        <el-descriptions-item label="价格信息">请在理疗商品管理模块查看</el-descriptions-item>
      </el-descriptions>
    </customDialog>
  </div>
</template>

<script lang="js">
import { physioListAll, changeEnableStatus, edit } from "@/api/physio"; // 理疗请求
import CustomTable from '@/components/CustomTable.vue';
import { CommonDTO } from '@/DTO/index.js'
import { Common } from './DTO/common';
import { dictText } from '@/utils/validateBase'
import customDialog from '@/components/customDialog/CustomDialog.vue';
import { ybCenterDrugDirectoryCategorySignList } from '@/utils/const';
import { isNull } from "../../../utils/validateBase";
export default {
  components: { CustomTable, customDialog },
  data() {
    return {
      loading: true, // 加载中
      searchForm: { artNo: null, searchValue: null, enableStatus: '', ybCode:'' }, // 查询表单
      editForm: {},
      drugRoleList: [],
      physioList: [], // 理疗列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      tableHeight: 0, // 表格最大高度
      dialogShow: false,
      deptId: this.$session.get('deptId'), // 医馆id
      rules: {
        physioName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
        ],
        price: [
          { required: true, message: '请输入商品零售价', trigger: 'blur' },
          // 数字，保留两位小数
          { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入数字，最多两位小数', trigger: 'blur' }
        ],
        // dictPhysioCode: [
        //   { required: true, message: '请输入医保编码', trigger: 'blur' },
        // ],
        types: [
          { required: true, message: '请选择类型', trigger: 'change' },
        ],
        executionMode: [
          { required: true, message: '请选择执行模式', trigger: 'change' },
        ],
        perUnit: [
          { required: true, message: '请选择执行单位', trigger: 'change' },
        ],
      

      },
      ybCenterDrugDirectoryCategorySignList: ybCenterDrugDirectoryCategorySignList,//药品类别
      levelOptions: [],//
      flattenLevelOptions: [],//
      listTable: [
        { label: "序号", type: "index", width: '80', fixed: 'left' },
        { label: "医馆", prop: "deptName", minWidth: "100", fixed: 'left' },
        { label: "货号", prop: "id", minWidth: "120", fixed: 'left' },
        { label: "是否禁用", formatter: (row => { return row.validFlag == '1' ? '是' : '否'  }), width: "100", fixed: 'left' },
        { label: "spuId", prop: "spuId", minWidth: "100", fixed: 'left' },
        // { label: "商品通用名称", prop: "physioCommonName", minWidth: "180" },
        { label: "商品名称", prop: "physioName", minWidth: "180", fixed: 'left' },
        {
          label: "一级分类", prop: "firstCategory", slotName: 'firstCategory', minWidth: "120"
        },
        {
          label: "二级分类", prop: "secondCategory", slotName: 'secondCategory', minWidth: "120"
        },
        { label: "单位", prop: "unit", slotName: 'unit', minWidth: "120" },
        { label: "医保编码", prop: "dictPhysioCode", minWidth: "150" },
        {
          label: "医保类别", prop: "ybCenterDrugDirectoryCategorySign", formatter: (row => {
            return dictText(row.ybCenterDrugDirectoryCategorySign, ybCenterDrugDirectoryCategorySignList)
          }), minWidth: "120"
        },
        { label: "雨诺类别", prop: "categoryFirstName", minWidth: "150" },
        { label: "零售大类", prop: "categorySecondName", minWidth: "150" },
        { label: "零售中类", prop: "categoryThirdName", minWidth: "150" },
        { label: "零售小类", prop: "categoryFourthName", minWidth: "150" },
        { label: "商品角色", prop: "roleName", minWidth: "150" },
        { label: "状态", prop: "enableStatus", minWidth: '90', slotName: 'enableStatus', fixed: "right" },
        { label: "操作", prop: "id", slotName: 'handle', fixed: "right" },
      ]
    };
  },
  async created() {
    this.tableHeight = document.documentElement.clientHeight - 260;
    await this.getDrugRole();
    this.getPhysiosList(); // 页面初始化获取理疗列表

    this.getGoodLevel();//获取分类列表
  },
  computed: {
    computedLevel() {
      let that = this;
      return function (level) {
        return dictText(level, that.flattenLevelOptions)
      }
    }
  },
  methods: {
    // 获取商品角色
    async getDrugRole() { 
      const res = await CommonDTO.getDrugRoleOrCate({ type: 'goodsRole' })
      if (res.errorCode == '0000') {
        this.drugRoleList = res.data
      }
    },
    //获取分类列表
    async getGoodLevel() {
      let res = await CommonDTO.getDictTypeTreeDTO('level')
      if (res.code == 200) {
        let data = Common.deleteEmptyChildren(res.data)
        this.levelOptions = data.filter(item => { return item.dictDataVal == '8' })
        this.flattenLevelOptions = Common.flattenChildren(data)
      }
    },
    // 请求所有理疗列表
    async getPhysiosList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await physioListAll(params);

      if (code == 200) {
        this.total = total;
        const options = this.$session.get('options');
        rows.forEach(item => {
          item.perUnit = isNull(item.perUnit) ? 30 : item.perUnit;
          options.forEach(kid => {
            if (item.deptId == kid.value) item.deptName = kid.label;
          })
          item.checked = item.enableStatus == 1
          const role = this.drugRoleList.find(v=>{ return v.code == item.roleId })
          item['roleName'] = role ? role.name : ''
        })
        this.physioList = rows;
      }
      this.loading = false;
    },

    // 改变理疗禁用状态
    async changeEnableStatusHandle(e, itemInfo) {
      const params = {
        physioId: itemInfo.physioId,
        deptId: itemInfo.deptId,
        enableStatus: e ? 1 : 2
      }
      try {
        const res = await changeEnableStatus(params)
        if (res.code != 200) {
          const index = this.physioList.findIndex(item => item.physioId == itemInfo.physioId)
          if (index > -1) {
            this.$set(this.physioList[index], 'checked', !e)
          }
        }
      } catch (error) {
        console.log('修改理疗状态失败', error)
      }
    },
    handleEdit(row) {
      // this.$set(this, 'editForm', row)
      this.editForm = _.cloneDeep(row)
      let levelArr = _.compact([row.firstCategory, row.secondCategory])
      this.$set(this.editForm, 'types', levelArr)
      this.dialogShow = true
    },
    /**
   * 关闭弹框
   */
    closeDialog() {
      this.dialogShow = false
    },
    /**
     * 确定
     */
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          edit(this.editForm).then(res => {
            if (res.code == 200) {
              this.$message.success('修改成功')
              this.dialogShow = false;
              this.getPhysiosList()
            }
          })
        }
      });

    },
    changePerUnit(val){
      if(isNull(val) || val == 30){
        this.editForm.perUnitCount = ''
      }
    }
  },
};
</script>

<style lang="less" scoped>
  .physio {
    box-sizing: border-box;
    padding: 20px;
  }

.search /deep/.el-select .el-input .el-select__caret {
  transform: rotateZ(180deg) translateY(3px);
}
.perUnitCount-input{
  width: 112px;
  margin: 0 12px;
  /deep/.el-input__inner{
    // width: 112px;
    padding: 0;
    padding-left: 12px;
    text-align: left;
  }
  /deep/.el-input-number__increase{
    display: none;
  }
  /deep/.el-input-number__decrease{
    display: none;
  }
}
.numberInput{
  height: 44px;
  display: flex;
  align-items: center;
  background: #F7F8F9;
  padding: 0 12px;
}
</style>